// "BatchId": "00000000-0000-0000-0000-000000000000",
// "OpdateringType": "OpdaterMedlem",
// "Medlem": {
//   "Medlemsnummer": 0,
//   "FoedselsDato": "2022-05-19T06:07:58.363Z",
//   "Afdeling": {
//     "Nummer": "string",
//     "Navn": "string"
//   },
//   "ErEgetMedlem": true,
//   "Medlemsident": 0,
//   "Fornavn": "string",
//   "Efternavn": "string",
//   "FuldeNavn": "string"
// },
// "Bruger": {
//   "Medlemsident": 0,
//   "Fornavn": "string",
//   "Efternavn": "string",
//   "FuldeNavn": "string"
// },
// "RegTid": "2022-05-19T06:07:58.363Z",
// "BehandlingTid": "2022-05-19T06:07:58.363Z",
// "OpdateringBatchStatus": "UnderOpdatering"

export type IUpdateBatchData = {
    BatchId: string
    OpdateringType: string
    Medlem: {
        Medlemsnummer: number
        FoedselsDato: string
        Afdeling: {
            Nummer: string
            Navn: string
        }
        ErEgetMedlem: boolean
        Medlemsident: number
        Fornavn: string
        Efternavn: string
        FuldeNavn: string
    }
    Bruger: {
        Medlemsident: 0
        Fornavn: string
        Efternavn: string
        FuldeNavn: string
    }
    RegTid: string
    BehandlingTid: string
    OpdateringBatchStatus: string
}

export type MemberOnUpdate = {
    number: number
    birthday: string
    department: {
        number: string
        name: string
    }
    isOwnMember: boolean
    id: number
    firstName: string
    lastName: string
    fullName: string
}

export type ProfileOnUpdate = {
    id: number
    firstName: string
    lastName: string
    fullName: string
}

export class UpdateBatch {
    batchId = ''

    type = ''

    member: MemberOnUpdate

    profile: ProfileOnUpdate

    created = ''

    updated = ''

    status: string

    public static build = (data: IUpdateBatchData): UpdateBatch => {
        const update = new UpdateBatch()

        update.batchId = data.BatchId
        update.type = data.OpdateringType
        update.created = data.RegTid
        update.updated = data.BehandlingTid
        update.member = {
            birthday: data.Medlem.FoedselsDato,
            department: {
                name: data.Medlem.Afdeling?.Navn || '',
                number: data.Medlem.Afdeling?.Nummer || '',
            },
            firstName: data.Medlem.Fornavn,
            lastName: data.Medlem.Efternavn,
            fullName: data.Medlem.FuldeNavn,
            id: data.Medlem.Medlemsident,
            isOwnMember: data.Medlem.ErEgetMedlem,
            number: data.Medlem.Medlemsnummer,
        }
        update.profile = {
            firstName: data.Bruger.Fornavn,
            lastName: data.Bruger.Efternavn,
            fullName: data.Bruger.FuldeNavn,
            id: data.Bruger.Medlemsident,
        }
        update.status = data.OpdateringBatchStatus

        return update
    }
}

export function mapUpdates(data: IUpdateBatchData[]): UpdateBatch[] {
    return data && data.map((update) => UpdateBatch.build(update))
}
